<template>
    <div class="page-wrapper">
        <div class="page-header">
            <WidgetToolbar :back="active_page == 'profiles'" @onBack="backToSkills()" title="Matrix"
                :icon="require('@/assets/admin-icon/menu/pie-chart-active.svg')">
                <template v-slot:leftOptions>
                    <widgetTabs v-model="activeTab" :tabs="[
                        {
                            title: 'General',
                            value: 'general',
                            icon: {
                                inactive: require('@/assets/matrix/general.svg'),
                                active: require('@/assets/matrix/general-active.svg')
                            }
                        },
                        {
                            title: 'Compare',
                            value: 'compare',
                            icon: {
                                inactive: require('@/assets/matrix/compare.svg'),
                                active: require('@/assets/matrix/compare-active.svg')
                            }
                        },
                    ]" @change="switchTab"></widgetTabs>

                </template>
                <div class="options">

                </div>
            </WidgetToolbar>
        </div>
        <SkillsChart v-if="active_page == 'general'" @ViewConsultantsProfiles="showConsultantsProfiles">
        </SkillsChart>
        <SkillsCompare v-if="active_page == 'compare'"></SkillsCompare>
        <ConsultantsProfiles v-if="active_page == 'profiles'" :form="formFilter"></ConsultantsProfiles>
    </div>
</template>
<script>
import { eventBus } from "@/main";
import SkillsChart from "./components/skillsChart.vue";
import ConsultantsProfiles from "./components/ConsultantsProfiles.vue";
import SkillsCompare from "./components/skillsCompare.vue";

export default {
    components: {
        SkillsChart,
        ConsultantsProfiles,
        SkillsCompare
    },
    data: () => ({
        activeTab: 1,
        active_page: 'general',
        formFilter: null

    }),
    mounted() {
        let vm = this;
    },
    computed: {
    },
    methods: {
        switchTab(tab) {
            let vm = this;
            vm.active_page = tab.value;
        },
        showConsultantsProfiles(form) {
            let vm = this;
            vm.formFilter = form;
            vm.active_page = "profiles"
        },
        backToSkills() {
            let vm = this;
            vm.formFilter = null;
            vm.active_page = "general"
        }
    },
};
</script>
  
<style lang="scss" scoped>
.page-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    background: #ebebeb;
    padding: 5px;

    .page-header {
        height: 38px;
        width: 100%;
        display: flex;
        align-items: center;
        margin-bottom: 5px;

        .options {
            display: flex;
            align-items: center;

            .search-account {
                width: 250px;
            }

            .btn-add {
                margin-left: 20px;
            }
        }
    }

}
</style>
  